<template>
  <div
    ref="wrap"
    class="wrap"
    :class="wrapCls">
    <div class="label">
      <span
        class="must-fill-in"
        v-if="required"></span>
      {{ label }}
    </div>
    <input
      v-if="[`text`, `password`].includes(type)"
      :class="inputCls"
      ref="input"
      :id="id"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      v-model="cValue"
      :maxlength="max"
      autocomplete="off"
      :disabled="disabled"
      @keyup="keyup"
    />
    <div
      v-if="[`file`].includes(type)"
      class="upload-wrap">
      <div class="upload">
        <div
          class="img"
          v-for="(url, index) in urls"
          :key="index">
          <img :src="url" />
          <i
            class="iconfont icon-guanbi"
            @click="removeImage"></i>
        </div>
        <div
          class="btn"
          v-show="urls.length === 0">
          <input
            type="hidden"
            :id="id"
            :name="name"
            v-model="cValue" />
          <input
            type="file"
            ref="input" />
          <i class="iconfont">&#xe641;</i>
          <span>上传图片</span>
        </div>
        <div class="desc">
          只支持png,jpg格式,最大1M。
        </div>
      </div>
    </div>
    <div
      v-if="[`imageCaptcha`].includes(type)"
      class="image-captcha">
      <input
        v-if="[`imageCaptcha`].includes(type)"
        :class="inputCls"
        ref="input"
        :id="id"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        v-model="cValue"
        :maxlength="max"
        autocomplete="off"
        :disabled="disabled"
        @keyup="keyup"
      />
      <img
        :src="captchaImageUrl"
        @click="refreshCaptchaImageUrl($event)" />
    </div>
    <div
      v-if="[`smsCaptcha`].includes(type)"
      class="sms-button">
      <input
        v-if="[`smsCaptcha`].includes(type)"
        :class="inputCls"
        ref="input"
        :id="id"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        v-model="cValue"
        :maxlength="max"
        autocomplete="off"
        :disabled="disabled"
        @keyup="keyup"
      />
      <a
        class="btn"
        :class="smsBtnDisabled?`disabled`:``"
        @click="handleSmsCaptchaClick"
      >{{ smsBtnText }}</a>
    </div>
    <div class="message">
      {{ message }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Schema from 'async-validator';
import {imgUpload, captchaImageUrl} from '@/service';

export default {
  name: 'Form2ItemInput',
  props: {
    label: {
      type: String,
    },
    id: {
      type: String,
      default: () => 'el_id_' + new Date().getTime() + Math.random(),
    },
    name: {
      type: String,
      default: () => 'el_name_' + new Date().getTime() + Math.random(),
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
    },
    rule: {
      type: Array,
      default: () => [],
    },
    max: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: [String, Number, Array],
    maxFile: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      cValue: '',
      validator: null,
      message: '',
      captchaImageUrl: captchaImageUrl + this.$store.state.system.deviceId,
      smsBtnText: '获取验证码',
      smsBtnDisabled: false,
      urls: [],
    };
  },
  computed: {
    wrapCls() {
      const clsArr = [];
      clsArr.push(this.message != '' ? 'input-error' : '');
      return clsArr.join(' ');
    },
    inputCls() {
      const clsArr = [];
      clsArr.push(this.disabled ? 'disabled' : '');
      return clsArr.join(' ');
    },
  },
  watch: {
    value(n, o) {
      const newVal = JSON.stringify(n);
      const oldVal = JSON.stringify(o);
      if (newVal === oldVal) return;
      this.cValue = n;
      if (['file'].includes(this.type)) {
        if (this.value && this.value !== '') {
          this.urls = this.value.split(',');
        }
      }
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        new Schema({
          value: this.rule,
        }).validate({value: this.cValue}, (err) => {
          if (err) {
            this.message = err[0].message;
            reject(false);
          } else {
            this.message = '';
            resolve(true);
          }
        });
      });
    },
    addEvent() {
      const input = this.$refs['input'];
      input.addEventListener('focus', this.focus);
      input.addEventListener('blur', this.blur);
    },
    removeEvent() {
      const input = this.$refs['input'];
      input.removeEventListener('focus', this.focus);
      input.removeEventListener('blur', this.blur);
    },
    keyup(e) {
      if (e.keyCode == 13) {
        this.validate();
        this.$emit('keyup-enter');
      }
      this.$emit('input', this.cValue);
    },
    focus() {
      this.$refs['wrap'].classList.add('focus');
      this.message = '';
    },
    blur() {
      this.$refs['wrap'].classList.remove('focus');
      this.validate();
    },
    // image----------------------------
    refreshCaptchaImageUrl(e) {
      e.target.src = e.target.src;
    },
    // file----------------------------
    removeImage() {
      this.urls = [];
      this.cValue = '';
      this.$emit('input', this.cValue);
    },
    readFile() {
      const $this = this;
      const input = this.$refs['input'];
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = function(event) {
        const formData = new FormData();
        formData.append('file', file);
        imgUpload(formData).then(({data}) => {
          data.forEach((item) => {
            $this.urls.push(item.domain + item.path);
          });
          $this.cValue = $this.urls.join(',');
          $this.$emit('input', $this.cValue);
        }).finally(() => {
          input.value = '';
        });
      };
      reader.readAsText(file);
    },
    addFileEvent() {
      const input = this.$refs['input'];
      input.addEventListener('change', this.readFile, false);
    },
    removeFileEvent() {
      const input = this.$refs['input'];
      input.removeEventListener('change', this.readFile);
    },
    // SmsCaptcha---------------
    handleSmsCaptchaClick() {
      if (this.smsBtnDisabled) return;
      this.$emit('sms-query', (countdown) => {
        this.smsBtnDisabled = true;
        let sec = countdown || 60;
        const time = setInterval(() => {
          if (sec < 1) {
            clearInterval(time);
            this.smsBtnDisabled = false;
            this.smsBtnText = '获取验证码';
          } else {
            sec--;
            this.smsBtnText = '等待' + sec + '(s)';
          }
        }, 1000);
      });
    },
  },
  mounted() {
    if (['text', 'password'].includes(this.type)) {
      this.addEvent();
    } else if (['imageCaptcha'].includes(this.type)) {
      this.addEvent();
    } else if (['smsCaptcha'].includes(this.type)) {
      this.addEvent();
    } else if (['file'].includes(this.type)) {
      this.addFileEvent();
    }
  },
  beforeDestroy() {
    if (['text', 'password', 'imageCaptcha'].includes(this.type)) {
      this.removeEvent();
    } else if (['file'].includes(this.type)) {
      this.removeFileEvent();
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .label {
    position: relative;
    line-height: 16px;
    color: #17233d;
    font-size: 12px;
    width: 100%;
    ::before {
      position: absolute;
      top: 1px;
      left: -11px;
      content: "*";
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 14px;
      color: #ed4014;
    }
  }
  .disabled {
    background: rgba(0, 0, 0, 0.04);
  }
  input {
    outline: 0;
    width: 100%;
    display: block;
    height: 40px;
    font-size: 12px;
    background: white;
    border-radius: 4px;
    padding: 0 6px;
    margin-top: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    transition: all ease-in 200ms;
    color: rgba(0, 0, 0, 0.65);
    &::-webkit-input-placeholder{
      color: rgb(191, 191, 191);
      font-weight: 100;
      font-family:  "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\\5FAE软雅黑", Arial, sans-serif;
    }
  }
  &.input-error {
    input {
      border-color: #fd5959;
      box-shadow: 0 0 3px 0 #fd5959;
    }
  }
  .upload-wrap {
    width: 100%;
    margin: 8px;
    .upload {
      position: relative;
      overflow: hidden;
      .img {
        width: 104px;
        height: 104px;
        border-radius: 3px;
        overflow: hidden;
        position: relative;
        margin-right: 8px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
        i {
          position: absolute;
          top: 0;
          right: 0;
          background: #f7f7f7;
          width: 16px;
          height: 16px;
          line-height: 16px;
          opacity: 0.8;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
        }
      }
      .btn {
        user-select: none;
        cursor: pointer;
        transition: all 0.2s;
        width: 104px;
        height: 104px;
        background: rgba(0, 0, 0, 0.02);
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
        flex-direction: column;
        &:hover {
          opacity: 0.8;
        }
        input[type="file"] {
          position: absolute;
          top: -42px;
          left: 0;
          opacity: 0;
          width: 100%;
          height: 300px;
          margin: 0;
          user-select: none;
          cursor: pointer;
          z-index: 1;
        }
        i {
          color: rgba(0, 0, 0, 0.45);
        }
        span {
          width: 100%;
          color: rgba(0, 0, 0, 0.45);
          font-size: 12px;
          text-align: center;
          margin-top: 10px;
        }
      }
      .desc {
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        margin-top: 8px;
      }
    }
  }
  .image-captcha {
    position: relative;
    width: 100%;
    img {
      position: absolute;
      top: 13px;
      right: 6px;
      border-radius: 3px;
    }
  }
  .sms-button {
    position: relative;
    width: 100%;
    .btn {
      position: absolute;
      top: 13px;
      right: 6px;
      background: white;
      color: #1890FF;
      border-radius: 4px;
      border: 0;
      padding: 3px 6px;
      font-size: 12px;
      text-align: center;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.disabled {
        background: initial;
        color: #ccc;
        cursor: default;
      }
    }
  }
  .message {
    height: 16px;
    margin-top: 8px;
    width: 100%;
    font-size: 12px;
    color: #fd5959;
  }
}
</style>
